angular.module('rjmNg.services').factory 'jobService', [
  "$http"
  "app"
  "$url"
  ($http, app, $url) ->
    return (type, status) ->
      jobService = {}

      if status is undefined
        jobService.url = $url("/client/#{app.getClientId()}/job/type/" + type)
      else
        jobService.url = $url("/client/#{app.getClientId()}/job/type/" + type + "/status/" + status)

      jobService.fetch = () ->
        $http.get(jobService.url)

      jobService.queue = (workload, successCallback, errorCallback) ->
        # replacement for global.js/queueJobBYId
        jobService.queueUrl = $url("/client/#{app.getClientId()}/job")

        # full $http method to specify data sent is formdata
        promise = $http({
          method: 'POST',
          url: jobService.queueUrl
          data: $.param({jobType: type, workload: workload}),
          headers: {'Content-Type': 'application/x-www-form-urlencoded'}
        })

        if successCallback?
          promise.then successCallback

        if errorCallback?
          promise.catch errorCallback

        return promise

      return jobService
  ]
